// Extra translations — subcategories, plan features, CreateEvent strings
// Merged into main translations in LanguageContext

const subcategories = {
  fr: {
    sub_wedding_ceremony: "Mariage", sub_engagement: "Fiançailles", sub_proposal: "Demande en mariage",
    sub_vow_renewal: "Renouvellement de vœux", sub_bachelor: "EVJF / EVG",
    sub_birthday_adult: "Anniversaire adulte", sub_birthday_child: "Anniversaire enfant",
    sub_birthday_surprise: "Fête surprise", sub_birthday_big: "Anniversaire marquant",
    sub_family_reunion: "Réunion de famille", sub_housewarming: "Pendaison de crémaillère",
    sub_family_celebration: "Célébration familiale", sub_anniversary: "Anniversaire de mariage",
    sub_baby_shower: "Baby shower", sub_gender_reveal: "Gender reveal", sub_birth: "Naissance",
    sub_baptism: "Baptême", sub_kids_party: "Fête d'enfant",
    sub_graduation: "Graduation", sub_diploma: "Remise de diplôme", sub_prom: "Bal de finissants",
    sub_student_gala: "Gala étudiant", sub_corporate: "Événement d'entreprise",
    sub_team_building: "Team building", sub_product_launch: "Lancement de produit",
    sub_conference: "Conférence", sub_networking: "Networking",
    sub_private_party: "Soirée privée", sub_bbq: "BBQ", sub_brunch: "Brunch",
    sub_pool_party: "Pool party", sub_new_year: "Nouvel An", sub_halloween: "Halloween",
    sub_custom: "Événement personnalisé", sub_community: "Communautaire / religieux",
    sub_group_travel: "Voyage de groupe", sub_sport_culture: "Sport / culture",
    create_step2_sub_title: "Précisez votre événement",
    create_step2_sub_desc: "Choisissez le type qui vous correspond.",
    create_step5_title: "Options recommandées",
    create_step5_desc: "Sélectionnées pour votre événement. Modifiez à votre guise.",
    create_date_error: "La date de fin doit être après la date de début.",
    create_options_note: "Modifiables depuis le tableau de bord organisateur.",
    create_checkout_iframe: "Le paiement n'est disponible que depuis l'application publiée.",
    plan_premium_desc: "Pour les grands événements",
    plan_feat_free_1: "15 participants", plan_feat_free_2: "8 photos live / participant",
    plan_feat_free_3: "7 jours des le debut", plan_feat_free_4: "Qualite web + validation",
    plan_feat_std_1: "50 participants", plan_feat_std_2: "10 photos / participant",
    plan_feat_std_3: "30 jours des le debut", plan_feat_std_4: "Validation organisateur", plan_feat_std_5: "Export ZIP HD",
    plan_feat_plus_1: "100 participants", plan_feat_plus_2: "15 photos / participant",
    plan_feat_plus_3: "IA: 1 500 analyses", plan_feat_plus_4: "Live Wall", plan_feat_plus_5: "3 suppressions / participant",
    plan_feat_prem_1: "250 participants", plan_feat_prem_2: "20 photos / participant",
    plan_feat_prem_3: "IA: 5 000 analyses", plan_feat_prem_4: "Outils grands evenements", plan_feat_prem_5: "5 suppressions / participant",
  },
  en: {
    sub_wedding_ceremony: "Wedding", sub_engagement: "Engagement", sub_proposal: "Marriage proposal",
    sub_vow_renewal: "Vow renewal", sub_bachelor: "Bachelor/Bachelorette",
    sub_birthday_adult: "Adult birthday", sub_birthday_child: "Kids birthday",
    sub_birthday_surprise: "Surprise party", sub_birthday_big: "Milestone birthday",
    sub_family_reunion: "Family reunion", sub_housewarming: "Housewarming",
    sub_family_celebration: "Family celebration", sub_anniversary: "Wedding anniversary",
    sub_baby_shower: "Baby shower", sub_gender_reveal: "Gender reveal", sub_birth: "Birth",
    sub_baptism: "Baptism", sub_kids_party: "Kids party",
    sub_graduation: "Graduation", sub_diploma: "Diploma ceremony", sub_prom: "Prom",
    sub_student_gala: "Student gala", sub_corporate: "Corporate event",
    sub_team_building: "Team building", sub_product_launch: "Product launch",
    sub_conference: "Conference", sub_networking: "Networking",
    sub_private_party: "Private party", sub_bbq: "BBQ", sub_brunch: "Brunch",
    sub_pool_party: "Pool party", sub_new_year: "New Year's Eve", sub_halloween: "Halloween",
    sub_custom: "Custom event", sub_community: "Community / religious",
    sub_group_travel: "Group travel", sub_sport_culture: "Sport / culture",
    create_step2_sub_title: "Specify your event",
    create_step2_sub_desc: "Choose the type that fits you.",
    create_step5_title: "Recommended options",
    create_step5_desc: "Selected for your event. Adjust as you like.",
    create_date_error: "The end date must be after the start date.",
    create_options_note: "Editable from the organizer dashboard.",
    create_checkout_iframe: "Payment is only available from the published app.",
    plan_premium_desc: "For large events",
    plan_feat_free_1: "15 participants", plan_feat_free_2: "8 live photos / participant",
    plan_feat_free_3: "7 days from start", plan_feat_free_4: "Web quality + review",
    plan_feat_std_1: "50 participants", plan_feat_std_2: "10 photos / participant",
    plan_feat_std_3: "30 days from start", plan_feat_std_4: "Organizer review", plan_feat_std_5: "HD ZIP export",
    plan_feat_plus_1: "100 participants", plan_feat_plus_2: "15 photos / participant",
    plan_feat_plus_3: "AI: 1,500 analyses", plan_feat_plus_4: "Live Wall", plan_feat_plus_5: "3 deletions / participant",
    plan_feat_prem_1: "250 participants", plan_feat_prem_2: "20 photos / participant",
    plan_feat_prem_3: "AI: 5,000 analyses", plan_feat_prem_4: "Large-event controls", plan_feat_prem_5: "5 deletions / participant",
  },
  es: {
    sub_wedding_ceremony: "Boda", sub_engagement: "Compromiso", sub_proposal: "Pedida de mano",
    sub_vow_renewal: "Renovación de votos", sub_bachelor: "Despedida de soltero/a",
    sub_birthday_adult: "Cumpleaños adulto", sub_birthday_child: "Cumpleaños infantil",
    sub_birthday_surprise: "Fiesta sorpresa", sub_birthday_big: "Cumpleaños especial",
    sub_family_reunion: "Reunión familiar", sub_housewarming: "Inauguración del hogar",
    sub_family_celebration: "Celebración familiar", sub_anniversary: "Aniversario de boda",
    sub_baby_shower: "Baby shower", sub_gender_reveal: "Revelación de sexo", sub_birth: "Nacimiento",
    sub_baptism: "Bautismo", sub_kids_party: "Fiesta infantil",
    sub_graduation: "Graduación", sub_diploma: "Entrega de diplomas", sub_prom: "Baile de graduación",
    sub_student_gala: "Gala estudiantil", sub_corporate: "Evento corporativo",
    sub_team_building: "Integración de equipo", sub_product_launch: "Lanzamiento de producto",
    sub_conference: "Conferencia", sub_networking: "Networking",
    sub_private_party: "Fiesta privada", sub_bbq: "BBQ", sub_brunch: "Brunch",
    sub_pool_party: "Fiesta en la piscina", sub_new_year: "Año Nuevo", sub_halloween: "Halloween",
    sub_custom: "Evento personalizado", sub_community: "Comunitario / religioso",
    sub_group_travel: "Viaje en grupo", sub_sport_culture: "Deporte / cultura",
    create_step2_sub_title: "Especifica tu evento",
    create_step2_sub_desc: "Elige el tipo que mejor te encaje.",
    create_step5_title: "Opciones recomendadas",
    create_step5_desc: "Seleccionadas para tu evento. Modifícalas a tu gusto.",
    create_date_error: "La fecha de fin debe ser posterior a la fecha de inicio.",
    create_options_note: "Modificables desde el panel del organizador.",
    create_checkout_iframe: "El pago solo está disponible desde la aplicación publicada.",
    plan_premium_desc: "Para grandes eventos",
    plan_feat_free_1: "15 participantes", plan_feat_free_2: "8 fotos en vivo / participante",
    plan_feat_free_3: "7 dias desde inicio", plan_feat_free_4: "Calidad web + revision",
    plan_feat_std_1: "50 participantes", plan_feat_std_2: "10 fotos / participante",
    plan_feat_std_3: "30 dias desde inicio", plan_feat_std_4: "Revision del organizador", plan_feat_std_5: "Exportacion ZIP HD",
    plan_feat_plus_1: "100 participantes", plan_feat_plus_2: "15 fotos / participante",
    plan_feat_plus_3: "IA: 1 500 analisis", plan_feat_plus_4: "Muro en vivo", plan_feat_plus_5: "3 borrados / participante",
    plan_feat_prem_1: "250 participantes", plan_feat_prem_2: "20 fotos / participante",
    plan_feat_prem_3: "IA: 5 000 analisis", plan_feat_prem_4: "Controles para eventos grandes", plan_feat_prem_5: "5 borrados / participante",
  },
  ar: {
    join_email_label: "البريد الإلكتروني",
    join_email_hint: "نحفظ بريدك الإلكتروني لتتمكن من استعادة الألبوم بعد الفعالية.",
    join_email_required: "أضف بريدك الإلكتروني لفتح وصول الضيف.",
    join_guest_access_btn: "فتح الألبوم",
    join_guest_access_hint: "لا يوجد تحقق الآن. سيُطلب التحقق بالبريد بعد نهاية الفعالية.",
    sub_wedding_ceremony: "زفاف", sub_engagement: "خطوبة", sub_proposal: "طلب اليد",
    sub_vow_renewal: "تجديد العهود", sub_bachelor: "حفلة العزوبية",
    sub_birthday_adult: "عيد ميلاد بالغ", sub_birthday_child: "عيد ميلاد طفل",
    sub_birthday_surprise: "حفلة مفاجأة", sub_birthday_big: "عيد ميلاد مميز",
    sub_family_reunion: "لمّة عائلية", sub_housewarming: "احتفال المنزل الجديد",
    sub_family_celebration: "احتفال عائلي", sub_anniversary: "ذكرى الزواج",
    sub_baby_shower: "حفلة استقبال المولود", sub_gender_reveal: "كشف جنس المولود",
    sub_birth: "ولادة", sub_baptism: "معمودية", sub_kids_party: "حفلة أطفال",
    sub_graduation: "تخرج", sub_diploma: "تسليم شهادات", sub_prom: "حفلة التخرج",
    sub_student_gala: "حفل الطلاب", sub_corporate: "فعالية شركة",
    sub_team_building: "بناء الفريق", sub_product_launch: "إطلاق منتج",
    sub_conference: "مؤتمر", sub_networking: "تواصل مهني",
    sub_private_party: "حفلة خاصة", sub_bbq: "شواء", sub_brunch: "برانش",
    sub_pool_party: "حفلة المسبح", sub_new_year: "رأس السنة", sub_halloween: "هالوين",
    sub_custom: "فعالية مخصصة", sub_community: "مجتمعي / ديني",
    sub_group_travel: "رحلة جماعية", sub_sport_culture: "رياضة / ثقافة",
    create_step2_sub_title: "حدد نوع فعاليتك",
    create_step2_sub_desc: "اختر النوع المناسب لك.",
    create_step5_title: "خيارات موصى بها",
    create_step5_desc: "تم اختيارها لفعاليتك. يمكنك تعديلها.",
    create_date_error: "يجب أن يكون تاريخ النهاية بعد تاريخ البداية.",
    create_options_note: "يمكن تعديلها من لوحة المنظّم.",
    create_checkout_iframe: "الدفع متاح فقط من التطبيق المنشور.",
    plan_premium_desc: "للفعاليات الكبيرة",
    plan_feat_free_1: "15 مشاركاً", plan_feat_free_2: "8 صور مباشرة / مشارك",
    plan_feat_free_3: "7 أيام من البداية", plan_feat_free_4: "جودة ويب + مراجعة",
    plan_feat_std_1: "50 مشاركاً", plan_feat_std_2: "10 صور / مشارك",
    plan_feat_std_3: "30 يوماً من البداية", plan_feat_std_4: "مراجعة المنظم", plan_feat_std_5: "تصدير ZIP HD",
    plan_feat_plus_1: "100 مشارك", plan_feat_plus_2: "15 صورة / مشارك",
    plan_feat_plus_3: "AI: 1 500 تحليل", plan_feat_plus_4: "الجدار المباشر", plan_feat_plus_5: "3 عمليات حذف / مشارك",
    plan_feat_prem_1: "250 مشارك", plan_feat_prem_2: "20 صورة / مشارك",
    plan_feat_prem_3: "AI: 5 000 تحليل", plan_feat_prem_4: "أدوات للفعاليات الكبيرة", plan_feat_prem_5: "5 عمليات حذف / مشارك",
  },
};

const featureCopy = {
  fr: {
    nav_photo: "Photo",
    nav_album: "Album",
    nav_explore: "Explorer",
    nav_create: "Créer",
    nav_primary: "Navigation principale",
    dashboard_summary: "Résumé du dashboard",
    share_qr: "Partager QR",
    open_gallery: "Voir la galerie",
    delete_event: "Supprimer l'événement",
    notification_deleted_title: "Notification supprimée",
    notification_deleted_desc: "Elle a été retirée de votre dashboard.",
    notification_delete_error: "Suppression impossible",
    notification_delete_retry: "Rechargez la page et réessayez.",
    notification_delete_aria: "Supprimer la notification",
    moderation_rejected: "Votre photo n'a pas été publiée par l'organisateur.",
    moderation_approved: "Votre photo est maintenant visible dans la galerie.",
    create_progress: "Progression de la création",
    create_secure_title: "Connexion sécurisée",
    create_secure_desc: "Connectez-vous d'abord. Vous pourrez ensuite créer votre événement sans ressaisir vos informations.",
    create_resuming_title: "Création de votre événement",
    create_resuming_desc: "Nous reprenons vos informations et préparons votre galerie.",
    create_confirmed_title: "Connexion confirmée",
    create_confirmed_desc: "Vous pouvez maintenant créer votre événement.",
    create_confirmed_action: "Créer mon événement",
    create_verify_title: "Vérification nécessaire",
    create_verify_desc: "La création automatique n'a pas pu se terminer. Vos informations sont conservées pour vérification.",
    create_blocked: "La création a été interrompue : {error}",
    create_review_action: "Vérifier les informations",
    create_network_error: "La connexion à Supabase a été interrompue. Vérifiez votre connexion et réessayez.",
    create_session_error: "Votre session a expiré. Reconnectez-vous puis relancez la création.",
    create_checkout_error: "Le paiement est temporairement indisponible.",
    guest_preview_label: "Aperçu invité",
    guest_preview_title: "Votre galerie privée",
    guest_preview_desc: "Les invités scanneront un QR code pour ajouter leurs photos.",
    guest_preview_cta: "Ajouter une photo",
    create_options_unavailable: "Les options avancées ne sont pas disponibles avec le plan Free.",
    event_access_saved: "Accès sauvegardé dans votre compte. Vous retrouverez cet album dans votre dashboard.",
    gallery_recent: "Récentes",
    gallery_popular: "Populaires",
    gallery_mine: "Mes photos",
    gallery_timeline: "Chronologie",
    gallery_empty: "Galerie vide",
    gallery_empty_desc: "Ajoutez la première photo de cet événement.",
    gallery_search_placeholder: "Rechercher par nom ou légende",
    gallery_search_label: "Rechercher dans la galerie",
    gallery_clear_search: "Effacer la recherche",
    gallery_no_results: "Aucun résultat pour « {query} »",
    role_participant: "Participant",
    participant_capacity: "Capacité des participants",
    status_expired: "Expiré",
    event_info_live_photos: "{count} photos live par participant",
    event_info_date: "Date",
    event_info_location: "Lieu",
    event_info_unspecified: "Non précisé",
    event_info_photo_limit: "{count} photos ({limit} max par participant)",
    event_info_guest_deletions: "Suppressions invité",
    event_info_max_per_guest: "{count} max par participant",
    event_info_moderation: "Modération",
    event_info_ai_included: "IA incluse ({count} analyses max)",
    event_info_organizer_review: "Validation par l'organisateur",
    event_info_access: "Accès",
    event_info_public: "Galerie publique",
    event_info_private: "Participants uniquement",
    event_info_status: "Statut",
    event_info_plan: "Formule",
    event_info_about: "À propos",
    event_info_details: "Détails",
    event_info_code_hint: "Partagez ce code pour inviter des participants.",
    event_info_free_note: "Avec le plan Free, chaque participant peut ajouter jusqu'à {count} photos prises en direct.",
    join_name_label: "Votre nom",
    join_name_placeholder: "Ex : Sarah M.",
    join_name_hint: "Ce nom aide l'organisateur a reconnaitre les participants.",
    join_name_required: "Ajoutez votre nom pour rejoindre cet evenement.",
    join_email_label: "Votre email",
    join_email_hint: "Votre email est enregistre pour retrouver l'album apres l'evenement.",
    join_email_required: "Ajoutez votre email pour ouvrir l'acces invite.",
    join_guest_access_btn: "Ouvrir l'album",
    join_guest_access_hint: "Pas de verification maintenant. Elle sera demandee apres la fin de l'evenement.",
    join_timeout_error: "La connexion prend trop de temps. Reessayez ou entrez le code.",
    join_load_error: "Impossible de charger cet evenement. Reessayez dans quelques secondes.",
    join_open_error: "Impossible d'ouvrir cet evenement. Reessayez dans quelques secondes.",
    join_sign_in_to_join: "Se connecter pour rejoindre",
    join_redirect_hint: "Vous serez redirige vers la connexion, puis rejoint automatiquement.",
    join_fast_hint: "Acces simple et securise en moins d'une minute.",
    join_step_scan: "Scanner",
    join_step_confirm: "Confirmer",
    join_step_album: "Album",
    join_scan_cta: "Ouvrir la camera",
    notif_photo_review_required: "{name} a ajoute une photo a verifier.",
    camera_back: "Arriere",
    camera_selfie: "Selfie",
    camera_switch: "Changer camera",
  },
  en: {
    nav_photo: "Photo",
    nav_album: "Album",
    nav_explore: "Explore",
    nav_create: "Create",
    nav_primary: "Primary navigation",
    dashboard_summary: "Dashboard summary",
    share_qr: "Share QR",
    open_gallery: "View gallery",
    delete_event: "Delete event",
    notification_deleted_title: "Notification deleted",
    notification_deleted_desc: "It was removed from your dashboard.",
    notification_delete_error: "Unable to delete",
    notification_delete_retry: "Reload the page and try again.",
    notification_delete_aria: "Delete notification",
    moderation_rejected: "Your photo was not published by the organizer.",
    moderation_approved: "Your photo is now visible in the gallery.",
    create_progress: "Creation progress",
    create_secure_title: "Secure sign-in",
    create_secure_desc: "Sign in first. You can then create your event without entering your details twice.",
    create_resuming_title: "Creating your event",
    create_resuming_desc: "We are restoring your details and preparing your gallery.",
    create_confirmed_title: "Sign-in confirmed",
    create_confirmed_desc: "You can now create your event.",
    create_confirmed_action: "Create my event",
    create_verify_title: "Verification required",
    create_verify_desc: "Automatic creation could not finish. Your details are saved for review.",
    create_blocked: "Creation was interrupted: {error}",
    create_review_action: "Review details",
    create_network_error: "The Supabase connection was interrupted. Check your connection and try again.",
    create_session_error: "Your session expired. Sign in again, then restart event creation.",
    create_checkout_error: "Checkout is temporarily unavailable.",
    guest_preview_label: "Guest preview",
    guest_preview_title: "Your private gallery",
    guest_preview_desc: "Guests will scan a QR code to add their photos.",
    guest_preview_cta: "Add a photo",
    create_options_unavailable: "Advanced options are not available on the Free plan.",
    event_access_saved: "Access saved to your account. You can find this album in your dashboard.",
    gallery_recent: "Recent",
    gallery_popular: "Popular",
    gallery_mine: "My photos",
    gallery_timeline: "Timeline",
    gallery_empty: "Empty gallery",
    gallery_empty_desc: "Add the first photo from this event.",
    gallery_search_placeholder: "Search by name or caption",
    gallery_search_label: "Search the gallery",
    gallery_clear_search: "Clear search",
    gallery_no_results: "No results for “{query}”",
    role_participant: "Participant",
    participant_capacity: "Participant capacity",
    status_expired: "Expired",
    event_info_live_photos: "{count} live photos per participant",
    event_info_date: "Date",
    event_info_location: "Location",
    event_info_unspecified: "Not specified",
    event_info_photo_limit: "{count} photos ({limit} max per participant)",
    event_info_guest_deletions: "Guest deletions",
    event_info_max_per_guest: "{count} max per participant",
    event_info_moderation: "Moderation",
    event_info_ai_included: "AI included ({count} analyses max)",
    event_info_organizer_review: "Organizer review",
    event_info_access: "Access",
    event_info_public: "Public gallery",
    event_info_private: "Participants only",
    event_info_status: "Status",
    event_info_plan: "Plan",
    event_info_about: "About",
    event_info_details: "Details",
    event_info_code_hint: "Share this code to invite participants.",
    event_info_free_note: "On the Free plan, each participant can add up to {count} photos captured live.",
    join_name_label: "Your name",
    join_name_placeholder: "E.g. Sarah M.",
    join_name_hint: "This name helps the organizer recognize participants.",
    join_name_required: "Add your name to join this event.",
    join_email_label: "Your email",
    join_email_hint: "Your email is saved so you can recover the album after the event.",
    join_email_required: "Add your email to open guest access.",
    join_guest_access_btn: "Open album",
    join_guest_access_hint: "No verification now. Email verification is requested after the event ends.",
    join_timeout_error: "The connection is taking too long. Try again or enter the code.",
    join_load_error: "Unable to load this event. Try again in a few seconds.",
    join_open_error: "Unable to open this event. Try again in a few seconds.",
    join_sign_in_to_join: "Sign in to join",
    join_redirect_hint: "You will be redirected to sign in, then joined automatically.",
    join_fast_hint: "Simple, secure access in under a minute.",
    join_step_scan: "Scan",
    join_step_confirm: "Confirm",
    join_step_album: "Album",
    join_scan_cta: "Open camera",
    notif_photo_review_required: "{name} added a photo that needs review.",
    camera_back: "Back",
    camera_selfie: "Selfie",
    camera_switch: "Switch camera",
  },
  es: {
    nav_photo: "Foto",
    nav_album: "Álbum",
    nav_explore: "Explorar",
    nav_create: "Crear",
    nav_primary: "Navegación principal",
    dashboard_summary: "Resumen del panel",
    share_qr: "Compartir QR",
    open_gallery: "Ver galería",
    delete_event: "Eliminar evento",
    notification_deleted_title: "Notificación eliminada",
    notification_deleted_desc: "Se eliminó de tu panel.",
    notification_delete_error: "No se pudo eliminar",
    notification_delete_retry: "Recarga la página e inténtalo de nuevo.",
    notification_delete_aria: "Eliminar notificación",
    moderation_rejected: "El organizador no publicó tu foto.",
    moderation_approved: "Tu foto ya está visible en la galería.",
    create_progress: "Progreso de creación",
    create_secure_title: "Inicio de sesión seguro",
    create_secure_desc: "Inicia sesión primero. Después podrás crear tu evento sin repetir tus datos.",
    create_resuming_title: "Creando tu evento",
    create_resuming_desc: "Estamos recuperando tus datos y preparando tu galería.",
    create_confirmed_title: "Inicio de sesión confirmado",
    create_confirmed_desc: "Ya puedes crear tu evento.",
    create_confirmed_action: "Crear mi evento",
    create_verify_title: "Verificación necesaria",
    create_verify_desc: "La creación automática no terminó. Tus datos se guardaron para revisarlos.",
    create_blocked: "La creación se interrumpió: {error}",
    create_review_action: "Revisar información",
    create_network_error: "La conexión con Supabase se interrumpió. Revisa tu conexión e inténtalo de nuevo.",
    create_session_error: "Tu sesión expiró. Inicia sesión de nuevo y reinicia la creación.",
    create_checkout_error: "El pago no está disponible temporalmente.",
    guest_preview_label: "Vista del invitado",
    guest_preview_title: "Tu galería privada",
    guest_preview_desc: "Los invitados escanearán un QR para añadir sus fotos.",
    guest_preview_cta: "Añadir una foto",
    create_options_unavailable: "Las opciones avanzadas no están disponibles en el plan Free.",
    event_access_saved: "Acceso guardado en tu cuenta. Encontrarás este álbum en tu panel.",
    gallery_recent: "Recientes",
    gallery_popular: "Populares",
    gallery_mine: "Mis fotos",
    gallery_timeline: "Cronología",
    gallery_empty: "Galería vacía",
    gallery_empty_desc: "Añade la primera foto de este evento.",
    gallery_search_placeholder: "Buscar por nombre o descripción",
    gallery_search_label: "Buscar en la galería",
    gallery_clear_search: "Borrar búsqueda",
    gallery_no_results: "No hay resultados para «{query}»",
    role_participant: "Participante",
    participant_capacity: "Capacidad de participantes",
    status_expired: "Vencido",
    event_info_live_photos: "{count} fotos en vivo por participante",
    event_info_date: "Fecha",
    event_info_location: "Lugar",
    event_info_unspecified: "Sin especificar",
    event_info_photo_limit: "{count} fotos ({limit} máx. por participante)",
    event_info_guest_deletions: "Borrados del invitado",
    event_info_max_per_guest: "{count} máx. por participante",
    event_info_moderation: "Moderación",
    event_info_ai_included: "IA incluida ({count} análisis máx.)",
    event_info_organizer_review: "Revisión del organizador",
    event_info_access: "Acceso",
    event_info_public: "Galería pública",
    event_info_private: "Solo participantes",
    event_info_status: "Estado",
    event_info_plan: "Plan",
    event_info_about: "Acerca de",
    event_info_details: "Detalles",
    event_info_code_hint: "Comparte este código para invitar participantes.",
    event_info_free_note: "En el plan Free, cada participante puede añadir hasta {count} fotos tomadas en directo.",
    join_name_label: "Tu nombre",
    join_name_placeholder: "Ej.: Sarah M.",
    join_name_hint: "Este nombre ayuda al organizador a reconocer a los participantes.",
    join_name_required: "Agrega tu nombre para unirte a este evento.",
    join_email_label: "Tu email",
    join_email_hint: "Guardamos tu email para recuperar el album despues del evento.",
    join_email_required: "Agrega tu email para abrir el acceso invitado.",
    join_guest_access_btn: "Abrir album",
    join_guest_access_hint: "Sin verificacion ahora. La verificacion se pedira despues del evento.",
    join_timeout_error: "La conexión tarda demasiado. Inténtalo de nuevo o ingresa el código.",
    join_load_error: "No se pudo cargar este evento. Inténtalo de nuevo en unos segundos.",
    join_open_error: "No se pudo abrir este evento. Inténtalo de nuevo en unos segundos.",
    join_sign_in_to_join: "Iniciar sesión para unirse",
    join_redirect_hint: "Serás redirigido al inicio de sesión y luego te unirás automáticamente.",
    join_fast_hint: "Acceso simple y seguro en menos de un minuto.",
    join_step_scan: "Escanear",
    join_step_confirm: "Confirmar",
    join_step_album: "Álbum",
    join_scan_cta: "Abrir cámara",
    notif_photo_review_required: "{name} agregó una foto para revisar.",
    camera_back: "Trasera",
    camera_selfie: "Selfie",
    camera_switch: "Cambiar cámara",
  },
  ar: {
    nav_photo: "صورة",
    nav_album: "الألبوم",
    nav_explore: "استكشاف",
    nav_create: "إنشاء",
    nav_primary: "التنقل الرئيسي",
    dashboard_summary: "ملخص لوحة التحكم",
    share_qr: "مشاركة رمز QR",
    open_gallery: "عرض الألبوم",
    delete_event: "حذف الفعالية",
    notification_deleted_title: "تم حذف الإشعار",
    notification_deleted_desc: "تمت إزالته من لوحة التحكم.",
    notification_delete_error: "تعذر الحذف",
    notification_delete_retry: "أعد تحميل الصفحة وحاول مرة أخرى.",
    notification_delete_aria: "حذف الإشعار",
    moderation_rejected: "لم ينشر المنظّم صورتك.",
    moderation_approved: "صورتك ظاهرة الآن في الألبوم.",
    create_progress: "تقدم إنشاء الفعالية",
    create_secure_title: "تسجيل دخول آمن",
    create_secure_desc: "سجّل الدخول أولاً، ثم أنشئ فعاليتك من دون إدخال معلوماتك مرتين.",
    create_resuming_title: "جارٍ إنشاء فعاليتك",
    create_resuming_desc: "نستعيد معلوماتك ونجهز ألبومك.",
    create_confirmed_title: "تم تأكيد تسجيل الدخول",
    create_confirmed_desc: "يمكنك الآن إنشاء فعاليتك.",
    create_confirmed_action: "إنشاء فعاليتي",
    create_verify_title: "التحقق مطلوب",
    create_verify_desc: "تعذر إكمال الإنشاء تلقائياً. تم حفظ معلوماتك للمراجعة.",
    create_blocked: "توقف الإنشاء: {error}",
    create_review_action: "مراجعة المعلومات",
    create_network_error: "انقطع الاتصال بـ Supabase. تحقق من اتصالك وحاول مرة أخرى.",
    create_session_error: "انتهت جلستك. سجّل الدخول مجدداً ثم أعد إنشاء الفعالية.",
    create_checkout_error: "الدفع غير متاح مؤقتاً.",
    guest_preview_label: "معاينة الضيف",
    guest_preview_title: "ألبومك الخاص",
    guest_preview_desc: "سيمسح الضيوف رمز QR لإضافة صورهم.",
    guest_preview_cta: "إضافة صورة",
    create_options_unavailable: "الخيارات المتقدمة غير متاحة في الخطة المجانية.",
    event_access_saved: "تم حفظ الوصول في حسابك. ستجد هذا الألبوم في لوحة التحكم.",
    gallery_recent: "الأحدث",
    gallery_popular: "الأكثر تفاعلاً",
    gallery_mine: "صوري",
    gallery_timeline: "التسلسل الزمني",
    gallery_empty: "الألبوم فارغ",
    gallery_empty_desc: "أضف أول صورة من هذه الفعالية.",
    gallery_search_placeholder: "البحث بالاسم أو الوصف",
    gallery_search_label: "البحث في الألبوم",
    gallery_clear_search: "مسح البحث",
    gallery_no_results: "لا توجد نتائج لعبارة «{query}»",
    role_participant: "مشارك",
    participant_capacity: "سعة المشاركين",
    status_expired: "منتهية",
    event_info_live_photos: "{count} صور مباشرة لكل مشارك",
    event_info_date: "التاريخ",
    event_info_location: "المكان",
    event_info_unspecified: "غير محدد",
    event_info_photo_limit: "{count} صور ({limit} كحد أقصى لكل مشارك)",
    event_info_guest_deletions: "حذف صور الضيف",
    event_info_max_per_guest: "{count} كحد أقصى لكل مشارك",
    event_info_moderation: "المراجعة",
    event_info_ai_included: "الذكاء الاصطناعي مشمول ({count} تحليل كحد أقصى)",
    event_info_organizer_review: "مراجعة المنظّم",
    event_info_access: "الوصول",
    event_info_public: "ألبوم عام",
    event_info_private: "للمشاركين فقط",
    event_info_status: "الحالة",
    event_info_plan: "الخطة",
    event_info_about: "حول الفعالية",
    event_info_details: "التفاصيل",
    event_info_code_hint: "شارك هذا الرمز لدعوة المشاركين.",
    event_info_free_note: "في الخطة المجانية، يمكن لكل مشارك إضافة حتى {count} صور ملتقطة مباشرة.",
    join_name_label: "اسمك",
    join_name_placeholder: "مثال: سارة م.",
    join_name_hint: "يساعد هذا الاسم المنظّم على معرفة المشاركين.",
    join_name_required: "أضف اسمك للانضمام إلى هذه الفعالية.",
    join_timeout_error: "يستغرق الاتصال وقتاً طويلاً. حاول مرة أخرى أو أدخل الرمز.",
    join_load_error: "تعذر تحميل هذه الفعالية. حاول مرة أخرى بعد لحظات.",
    join_open_error: "تعذر فتح هذه الفعالية. حاول مرة أخرى بعد لحظات.",
    join_sign_in_to_join: "تسجيل الدخول للانضمام",
    join_redirect_hint: "سيتم توجيهك إلى تسجيل الدخول، ثم الانضمام تلقائياً.",
    join_fast_hint: "وصول بسيط وآمن خلال أقل من دقيقة.",
    join_step_scan: "مسح",
    join_step_confirm: "تأكيد",
    join_step_album: "الألبوم",
    join_scan_cta: "فتح الكاميرا",
    notif_photo_review_required: "أضاف {name} صورة تحتاج إلى مراجعة.",
    camera_back: "الخلفية",
    camera_selfie: "سيلفي",
    camera_switch: "تبديل الكاميرا",
  },
};

export const extraTranslations = Object.fromEntries(
  Object.keys(subcategories).map((lang) => [
    lang,
    { ...subcategories[lang], ...(featureCopy[lang] || {}) },
  ])
);
